<template>
  <div>
    <input style="display:none;" type="text" :value="comparisonField" id="comparisonField" name="comparisonField" ref="comparisonField" :aria-labelledby="name"/>
    <doe-label :name="name" :required="fieldRequired">
      {{ label }} confirmation
    </doe-label>
    <span v-if="prefix" class="absolute border-gray-800 border-r font-sans leading-snug py-2 subpixel-antialiased font-bold text-center text-black text-xl max-w-xs w-full">{{ prefix }}</span>
    <input
      autocomplete="off"
      :type="type"
      :key="name"
      :name="name"
      :id="name"
      :value="value"
      :placeholder="placeholder"
      v-validate="confirmationValidation"
      :data-vv-as="label"
      :class="{ hasError: errors.has(name), hasPrefix: prefix, 'max-w-3xl': this.type === 'email', 'max-w-2xl': this.type !== 'email'  }"
      :aria-describedby="generateAriaDescription(name)"
      @input="$emit('input', $event.target.value)"
      @paste="onPaste"
      maxlength="140"
    />
    <doe-error v-if="errors.has(name)" :description="ariaErrorDescID(name)">{{ errors.first(name) }}</doe-error>
    <doe-hint :hint="hint" :description="ariaDescID(name)" />
  </div>
</template>

<script>
import dynamicValues from "@/mixins/dynamicValues";
import DoeLabel from "@/components/field/Label";
import DoeHint from "@/components/field/Hint";
import DoeError from "@/components/field/Error";

export default {
  name: "DoeTextConfirmation",
  mixins: [dynamicValues],
  inject: {
    $validator: "$validator"
  },
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: String
    },
    label: {
      type: String,
      required: true
    },
    fieldRequired: {
      type: Boolean,
      default: false
    },
    prefix: {
      type: String
    },
    type: {
      type: String,
      default: "text",
      validator: value => {
        return ["text", "password", "number"].indexOf(value) !== -1;
      }
    },
    validation: {
      required: false
    },
    placeholder: {
      type: String
    },
    hint: {
      type: [Array, String]
    },
    comparisonGetter: {
      type: String,
      required: true
    }
  },
  components: {
    DoeLabel,
    DoeHint,
    DoeError
  },
  computed: {
    comparisonField() {
      return this.$store.getters[this.comparisonGetter] ? this.$store.getters[this.comparisonGetter] : "";
      // console.log(this.$store.getters[this.comparisonGetter]);
      // return this.$store.getters[this.comparisonGetter];
    },
    confirmationValidation() {
      if(this.comparisonField) {
        if(this.value!=undefined && this.value!=null && this.value.toLowerCase() === this.comparisonField.toLowerCase()) {
          return { 'required': false, 'email': true, 'regex': /@(?!det.nsw.edu.au)/ }
        } else {
          return this.validation;
        }
      } else {
        return this.validation;
      }
    }
  },
  methods: {
    onPaste($event) {
      $event.preventDefault();
    },
    generateAriaDescription(fieldName) {
      if (this.errors.has(fieldName)) {
        return this.ariaErrorDescID(fieldName);
      }
      if (this.hint) {
        return this.ariaDescID(fieldName);
      }
      return false;
    },
    ariaDescID(fieldName) {
      return `${fieldName}Description`;
    },
    ariaErrorDescID(fieldName) {
      return `${fieldName}ErrorDescription`;
    }
  }
};
</script>

<style lang="scss" scoped>
input {
  @apply bg-gray-300 border border-gray-800 rounded font-sans leading-snug max-w-3xl px-3 py-2 subpixel-antialiased text-gray-900 text-xl w-full;
  &:hover {
    @apply border-blue-900;
    box-shadow: 0 0 0 1px #041e42;
  }
  &:focus {
    @apply border-blue-900;
    box-shadow: 0 0 0 1px #041e42;
    outline: 1px solid #041e42;
    outline-offset: 3px;
  }
}
input.hasPrefix {
  padding-left: 70px;
}
input.hasError {
  border-color: #d0021b;
}
</style>
